import React, {
  Component, useState,useEffect
} from 'react';
import Menu from "../Menu";
import Header from '../Header';
import moment from "moment";
import { Select } from 'antd';
import { DatePicker, Space } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { doGetVendorList, SaveVendorContractMappingInfo, VendorList, doGetVendorContractList,VendorContractList, getAssetDetails, apiCallStatus } from './actions/vendorService';
import { Switch } from 'antd';
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import Cookie from 'js-cookie';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import Spinner from '../../UIComponents/Spinner/Spinner';
import { SignalCellularNoSimOutlined } from '@mui/icons-material';
import LZString from 'lz-string';
const { Option } = Select;

const VendorContractMapping = () => {
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData)
  const userID = user['userId'];
  const vendorContractList = useSelector(state => state?.vendorList?.VendorContractDetails)
  const existingContracts = useSelector(state => state?.vendorList?.VendorContractDetails?.ExistingContracts)
  const assetDetails = useSelector(state => state?.vendorList?.AssetDetails)
  const [isSubmit, setIsSubmit] = useState(false)
  const [Vendor, setVendor] = useState('')
  const [storeImage, setStoreImage] = useState("");
  const [storeImageName, setStoreImageName] = useState("");
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');
  const apiInfo = useSelector(state => state?.vendorList)
  const [mainCategory, setMainCategory] = useState([])
  const [storeId, setStoreId] = useState('')
  const [subCategory, setSubCategory] = useState([]);
  const [assetList, setAssetList] = useState([]);
  const [vendorListData, setVendorList] = useState([])
  const [assetDetailsInfo, setAssetDetailsInfo] = useState([])
  const navigate = useNavigate();
  // console.log(vendorContractList)
  const dispatch = useDispatch()
  const [form, setState] = useState({
    fed_id: userID,
    vendorcontractmapid: '',
    vendorid: '',
    maincategoryid: [],
    subcategoryid: [],
    assetid: [],
    contractstartdate: '',
    contractenddate: '',
    vendorcontractmapbase64: '',
    contract_file_name: '',
    storeid: '',
    vendorstatus: '',

  })
  const _doNavToVendors = () => {
    navigate("/Vendors");
  };
  const _doSelectVendor = (event) => {

    setVendor(event.target.value)
  }

  const selectVendor = (value) => {

    let filteredData = vendorContractList?.VendorsDropDown.filter(ele => ele.vendor_row_id == value)
    // console.log(filteredData,'filteredDAta');
    // console.log(value + "value")
    // console.log(filteredData + "filterData")
    // setAddForm({ ...addForm, vendor_company_name: value })
    // setVendorInfo(filteredData[0]);
    setMainCategory(vendorContractList?.MainCategory);
    setMobileNumber(filteredData[0]?.mobile_number1)
    setEmail(filteredData[0]?.email_address1)
    // setState({...form, mobilenumber:filteredData[0].mobile_number1, email:filteredData[0].email_address1 })

  }



  const setSelectedStoreFile = (file) => {
    // const formData = new FormData();
    // formData.append('file', file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setStoreImageName(file.name);
      let encoded = setStoreImage(reader.result.toString().replace(/^data:(.*,)?/, ''))
    }
    reader.onerror = error => console.log(error)
    
  }
  const doSubmit = () => {
    setIsSubmit(true);
    if (form.vendorid == '') return;
    else if (form.maincategoryid == '') return;
    else if (form.subcategoryid == '') return;
    else if (form.assetid == '') return;
    else if (form.contractstartdate == '') return;
    else if (form.contractenddate == '') return;
    else if (storeImage == '') return;
    else if (form.storeid == '') return;
    console.log(form, 'form');
    
    form.contract_file_name = storeImageName;
    form.vendorcontractmapbase64 = storeImage;
    form.vendorcontractmapid = 0;
    // form.vendorid ? form.vendorstatus = 1 : form.vendorstatus = 0
    form.vendorstatus = form.vendorid ?1:0;
    dispatch(SaveVendorContractMappingInfo(form))
  }
  const dataHandler = (value)=>{
    setStoreId(value)
    // console.log(document.getElementsByTagName("input"),'queryselectory')
    // // console.log(document.getElementById("rc_select_4").innerHTML,'innerdata')
    // document.getElementsByClassName("ant-select-selection-item").innerText='helloworld'
    // document.getElementById("rc_select_4").innerText='helloworld';
    setVendorList(vendorContractList?.VendorsDropDown)
    setSubCategory([])
    setAssetList([])
    form.maincategoryid= []
    form.subcategoryid = []
    form.assetid = []
    setState({...form, maincategoryid:[],subcategoryid:[],assetid:[]})
  }
  
  const mainCategoryHandler = (value) =>{
      var sub= []
      for(let i=0; i<value.length;i++){
        var dat = vendorContractList?.SubCategory?.filter(ele => ele.maintenance_maincategory_id == value[i] && ele.store_id == form.storeid).map(data=>sub.push(data))
      }
      setSubCategory(sub)

      let val=[]
      for(let i=0;i<form.subcategoryid.length;i++){
        var data = form.subcategoryid.filter(ele=>sub[i]?.id=== ele ).map(data=>val.push(data))
      }
      // console.log(val,'inside for loop');
      // setState({ ...form, maincategoryid: value,subcategoryid:val });
      //newly added data for clearing specific data
      var filtExt = existingContracts.filter(ele=> ele.vendor_id ==form.vendorid && ele.store_id == storeId).map(ele=>ele.string_agg)
      if(filtExt.length>0){
        filtExt = Array.from(filtExt[0]?.split(','),Number)
      }
      var asset = []
      for(let i= 0;i<val.length;i++){
        var fetcheddata = vendorContractList.AssetList.filter(ele =>(ele.store_id == storeId&&ele.sub_category_id==val[i])).map(data=>asset.push(data))
      }
      var toDelete = new Set(filtExt);
      const newArray = asset.filter(obj=> !toDelete.has(obj.asset_id))
      // console.log(newArray,'newArray')
      // console.log(form.assetid,'form.assetid')
      setAssetList(newArray)
      let newAsset = []
      for(let i = 0;i<form.assetid.length;i++){
      // console.log('inside assetid loop')
      let newAssetData = form.assetid.filter(ele=>ele ==newArray[i]?.asset_id).map(data=>newAsset.push(data))
      }
      // console.log(newAsset,'newAsset')
      setState({...form,
        maincategoryid: value,
        subcategoryid:val, 
        assetid:[]
      })
      fetchAssetInfo(val)
      if(value.length==0|| val.length == 0){
        setAssetDetailsInfo([])
      }
  }

  const subCategoryHandler = (value)=>{
    // console.log(existingContracts ,'existingContracts')
    // console.log(storeId,'storeId')
    // var filtExt = existingContracts.filter(ele=> ele.store_id == storeId).map(ele=>ele.string_agg)
    // console.log(filtExt[0],'before if')
    // if(filtExt.length>0){
    //   // console.log('inside if')
    //   filtExt = Array.from(filtExt[0]?.split(','),Number)
    // }
    // console.log(filtExt,'filtExt')
    // var asset = []
    // for(let i= 0;i<value.length;i++){
    //   var fetcheddata = vendorContractList.AssetList.filter(ele =>(ele.store_id == storeId&&ele.sub_category_id==value[i])).map(data=>asset.push(data))
    // }

    // console.log(asset,'assetData')
    // var toDelete = new Set(filtExt);
    // // console.log(toDelete,'toDelete')
    // const newArray = asset.filter(obj=> !toDelete.has(obj.asset_id))
    // // console.log(newArray,'newArray')
    // //newly added
    // // console.log(form.assetid,'form.assetid')
    // let newAsset = []
    // for(let i = 0;i<form.assetid.length;i++){
    //   // console.log('inside assetid loop')
    //   let newAssetData = form.assetid.filter(ele=>ele ==newArray[i]?.asset_id).map(data=>newAsset.push(data))
    // }
    // form.assetid=newAsset
    // console.log('inside handler')
    console.log('ASSETID ==>',form.assetid)

    form.assetid=[]
    setState({...form, assetid:[]})

    // setAssetList(newArray)
    // assetDetailsInfo=[]
      // setAssetDetailsInfo([])
      fetchAssetInfo(value);
  }
  useEffect(()=>{
    dispatch(doGetVendorContractList(userID))
  },[])
  const fetchAssetInfo = (subidsPayload='') =>{
    if(form.subcategoryid.length==0)return;
    let payload = {
      storeId: form.storeid,
      vendorId: form.vendorid,
      subcategoryId :subidsPayload ? subidsPayload.toString():form.subcategoryid.toString()
    }
    dispatch(getAssetDetails(payload))
  }
  const CheckIsVendorExist = () =>{
    if(form.storeid =="") return;
    if(form.vendorid =="") return;
    let isExist = vendorContractList?.VendorsContractMappingList.some((item)=> (item.store_id == form.storeid&& item.vendor_id == form.vendorid))
    isExist && dispatch(apiCallStatus({
      message: 'Vendor is already in contract mapping. Kindly Use Edit Operation for Any Contract Changes',
    modalOpen: true,
    loading: false,
    apiStatus:false,
    }));
  }
  useEffect(()=>{
    if(assetDetails.length>0){
      setAssetDetailsInfo(assetDetails)
      // let assetIds = assetDetails.filter(ele=> ele.assets_exists === "True" ).map(ele=>ele.id)
      for(let i =0; i<form.assetid;i++){
        // let assetidsinfo = assetDetailsInfo.forEach(ele=> ele.sub_category_id == )

      }
    }
  },[assetDetails])
  return (
    <div>
      {apiInfo.modalOpen ? (
        <MessageBox
          message={apiInfo.message}
          // signout={false}
          onClose={() => {
            dispatch(doGetVendorContractList(userID))
            navigate('/VendorContract')
          }
          }
        />
      ) : null}
      
        <Header title={"Vendor Contract Mapping"} />
        <Menu />
        <div className='content-wrapper'>
          {apiInfo.loading ? (
            <Spinner />
          ) : (
            <section className='content top-space'>
              <div className="m-panel">
                <div className="m-panel__body">
                  <div className="row m-grid">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Store*</label>
                        <Select className="form-control"
                          onChange={(value) => (dataHandler(value),setState({ ...form, storeid: value }))}
                          showSearch 
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          value={form.storeid}
                          filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {
                            vendorContractList?.StoresDropdown.map(item => (
                              <Option key={item.store_id} value={item.store_id} >{item.store_name}</Option>
                            ))
                          }
                        </Select>
                        {form.storeid == '' && isSubmit == true ? <span className="text-danger">Please Select Store</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Vendor*</label>
                        {/* <select className="form-control m-form__input" onChange={e=>{setState({...form,vendorid:e.target.value})}
                        showSearch placeholder='please'
                      }>
                          <option>-- Please Select --</option>
                          <option>Vendor 1</option>
                          <option>Vendor 2</option>
                          {
                            vendorContractList?.VendorsContractMappingList.map(item=>(
                              // console.log(item)
                              // <option>{item.vendor_company_name} </option>
                              <Option key={item.vendor_id} value={item.vendor_id}>{item.vendor_company_name}</Option>
                            ))
                          }
                        </select> */}
                        <Select className="form-control"
                          showSearch placeholder="-- Please Select --"
                          optionFilterProp="children"
                          onChange={(value) => (selectVendor(value), setState({ ...form, vendorid: value }))}
                          value={form.vendorid}
                          onBlur={()=>{
                            return CheckIsVendorExist()
                          }}
                          filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          }                        
                        >{
                            vendorListData.map(item => (
                              <Option key={item.vendor_row_id} value={item.vendor_row_id}>{item.vendor_company_name}</Option>
                            ))
                          }
                        </Select>
                        {form.vendorid == '' && isSubmit == true ? <span className="text-danger">Please Select Vendor</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group select_h150">
                        <label htmlFor='exampleInput'>Main Category Name*</label>
                        <Select className="form-control"
                          mode='multiple'
                          allowClear={true}
                          onChange={(value) => (mainCategoryHandler(value))}
                          showSearch placeholder="-- Please Select --"
                          optionFilterProp="children"
                          value={form.maincategoryid}
                          filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                        }
                        >{
                            mainCategory.map((item,index) => (
                              <Option key={index} value={item.id} >{item.name}</Option>
                            ))
                          }
                        </Select>
                        {form.maincategoryid == '' && isSubmit == true ? <span className="text-danger">Please Select Main Category Name</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group select_h150">
                        <label htmlFor='exampleInput'>Sub Category Name*</label>
                        <Select className="form-control"
                          allowClear={true}
                          mode='multiple'
                          showSearch placeholder='-- Please Select --'
                          onChange={value => (subCategoryHandler(value),setState({ ...form, subcategoryid: value }))}
                          optionFilterProp="children"
                          value={form.subcategoryid}
                          filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          }
                          onBlur={()=>{
                            fetchAssetInfo()
                          }}
                        >
                          {
                            subCategory.map((item,index) => {
                              
                              return (
                                <Option key={index} value={item.id} >{item.name}</Option>
                              )
                            })
                          }
                        </Select>
                        {form.subcategoryid == '' && isSubmit == true ? <span className="text-danger">Please Select Sub Category Name</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group select_h150">
                        <label htmlFor='exampleInput'>Asset*</label>
                        <Select className="form-control"
                          mode='multiple'
                          allowClear={true}
                          onChange={(value) => setState({ ...form, assetid: value })}
                          showSearch placeholder="-- Please Select --"
                          optionFilterProp="children"
                          value={form.assetid}
                          filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {
                            // assetList.map((item,index) => (
                            //   <Option key={index} value={item.asset_id} >{item.asset_name}</Option>
                            // ))
                            assetDetailsInfo.map((item,index) => (
                              <Option key={index} value={item.id} >{item.asset_name}</Option>
                            ))
                          }
                        </Select>
                        {form.assetid == '' && isSubmit == true ? <span className="text-danger">Please Select Asset</span> : null}
                      </div>
                    </div>
                    

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Vendor mobile number*</label>
                        <input type="text" className="form-control" disabled value={mobileNumber} />
                      </div>
                    </div>


                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Vendor email id*</label>
                        <input type="text" className="form-control" disabled value={email} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Contract start date*</label>
                        <DatePicker className="form-control"  format={'YYYY-MM-DD'} onChange={(date, dateString) => setState({ ...form, contractstartdate: dateString })} />
                        {form.contractstartdate == '' && isSubmit == true ? <span className="text-danger">Please Select Contract start date</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Contract end date*</label>
                        <DatePicker className="form-control"  format={'YYYY-MM-DD'} onChange={(date, dateString) => setState({ ...form, contractenddate: dateString })} />
                        {form.contractenddate == '' && isSubmit == true ? <span className="text-danger">Please Select Contract end date</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Upload document*</label>
                        <input type="file" className="form-control" onChange={(e) => setSelectedStoreFile(e.target.files[0])} accept={".pdf"}/>
                      </div>
                      {storeImage.trim() == '' && isSubmit == true ? <span className="text-danger">Please Select  File</span> : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-right">
                  <div className="m-page__button top-space">

                    <Link className="option" to='/VendorContract'>
                      <button type='button' className='btn muted-button  deca-btn-orange'  onClick={()=>dispatch(VendorList(true))} >Back</button>
                    </Link>

                    <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={doSubmit}>Submit</button>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
    </div>
  )
}

export default VendorContractMapping;